module.exports = __webpack_public_path__ + "static/media/operating-system.8291fa44.svg";